<template>
  <div ref="dropdown-widget" class="dropdown-widget">
    <div class="selected" @click="clickInput">
      <div class="image-container" v-if="selectedIndex !== null && options[selectedIndex].image">
        <img :src="options[selectedIndex].image">
      </div>
      <div class="name" v-if="selectedIndex !== null">
        {{ $i18n.locale === 'th' ? options[selectedIndex].label : options[selectedIndex].labelEn }}
      </div>
      <div class="placeholder" v-if="selectedIndex === undefined || selectedIndex === null">
        {{ placeholder || `${$t('DropdownWidget.select')}` }} {{ isRequired ? '*' : '' }}
      </div>
      <img class="arrow-dropdown" :class="{active: showDropdown}" :src="util.getImagePath('arrow_up_blue@2x.png')" :srcset="util.getImageSet('arrow_up_blue')">
    </div>
    <div class="dropdown" v-show="options.length > 0 && showDropdown">
      <input type="search" autocomplete="none" v-model="keyword" @keydown.down="down" @keydown.up="up">
      <div ref="option-list" class="option-list">
        <div class="option-row"
          @click="select('')"
          :class="{'selected-row': '' === selectedValue}">
          <div class="name">
            {{ $t('DropdownWidget.unselect') }}
          </div>
        </div>
        <div class="option-row"
          v-for="option in filteredOptions"
          :key="option.value" @click="select(option.value)"
          :class="{'selected-row': option.value === selectedValue}">
          <div class="image-container" v-if="option.image !== ''">
            <img :src="option.image" loading="lazy">
          </div>
          <div class="name">
            {{ $i18n.locale === 'th' ? option.label : option.labelEn }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropdownWidget',
  props: {
    value: null,
    options: {
      type: Array,
      default: [],
      required: true
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      keyword: '',
      showDropdown: false,
      selectedValue: null,
      selectedIndex: null
    }
  },
  mounted () {
    var self = this
    self.$root.$on('clickOnWindow', self.clickOnWindow)
  },
  computed: {
    filteredOptions () {
      var self = this
      return (self.options || []).filter(option => {
        var isMatchTh = option.label.toLowerCase().indexOf(self.keyword.toLowerCase()) !== -1
        var isMatchEn = option.labelEn.toLowerCase().indexOf(self.keyword.toLowerCase()) !== -1
        var isEmptyKeyword = self.keyword === ''
        return isMatchTh || isMatchEn || isEmptyKeyword
      })
    }
  },
  methods: {
    clickOnWindow (e) {
      var self = this
      if ((self.options || []).length > 0 && self.showDropdown) {
        self.showDropdown = (self.$refs['dropdown-widget'] === e.target || self.$refs['dropdown-widget'].contains(e.target))
      }
    },
    clickInput () {
      var self = this
      self.showDropdown = !self.showDropdown
    },
    select (value) {
      var self = this
      self.selectedValue = value
      var index = (self.options || []).map(option => { return option.value }).indexOf(self.selectedValue)
      self.selectedIndex = index > -1 ? index : null
      self.$nextTick(() => {
        self.showDropdown = false
      })
    },
    down () {
      var self = this
      if (self.selectedValue !== null) {
        var index = self.filteredOptions.map(option => { return option.value }).indexOf(self.selectedValue)
        if (index !== -1) {
          index++
          if (index >= self.filteredOptions.length) {
            self.selectedIndex = self.filteredOptions.length - 1
          } else {
            self.selectedIndex = index
          }
          self.selectedValue = self.filteredOptions[self.selectedIndex].value
        }
      } else {
        self.selectedIndex = 0
        self.selectedValue = self.filteredOptions[self.selectedIndex].value
      }
    },
    up () {
      var self = this
      if (self.selectedValue !== null) {
        var index = self.filteredOptions.map(option => { return option.value }).indexOf(self.selectedValue)
        if (index !== -1) {
          index--
          if (index < 0) {
            self.selectedIndex = 0
          } else {
            self.selectedIndex = index
          }
          self.selectedValue = self.filteredOptions[self.selectedIndex].value
        }
      } else {
        self.selectedIndex = 0
        self.selectedValue = self.filteredOptions[self.selectedIndex].value
      }
    },
    updateScrollTop () {
      var selectedRow = document.querySelector('.selected-row')
      if (selectedRow) {
        selectedRow.scrollIntoView()
      }
    }
  },
  watch: {
    showDropdown () {
      var self = this
      self.$nextTick(() => {
        if (self.showDropdown) {
          // self.updateScrollTop()
        }
      })
    },
    selectedIndex () {
      var self = this
      self.$nextTick(() => {
        // self.updateScrollTop()
        if (self.selectedIndex === null) {
          self.$emit('input', {
            value: '',
            label: '',
            labelEn: ''
          })
        } else {
          var index = (self.options || []).map(option => { return option.value }).indexOf(self.selectedValue)
          self.$emit('input', self.options[index])
        }
      })
    },
    options () {
      var self = this
      self.$nextTick(() => {
        if (self.selectedValue !== '') {
          var index = (self.options || []).map(option => { return option.value }).indexOf(self.selectedValue)
          self.selectedIndex = index > -1 ? index : null
        }
      })
    },
    value (newValue) {
      var self = this
      self.$nextTick(() => {
        self.selectedValue = newValue.value
        var index = (self.options || []).map(option => { return option.value }).indexOf(self.selectedValue)
        self.selectedIndex = index > -1 ? index : null
      })
    }
  },
  beforeDestroy () {
    var self = this
    self.$root.$off('clickOnWindow')
  }
}
</script>

<style scoped>
  .dropdown-widget {
    position: relative;
  }

  .selected {
    width: calc(100% - 16px);
    height: 100%;
    border: none;
    background-color: transparent;
    box-sizing: border-box;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .selected > .image-container {
    height: 16px;
    width: 16px;
    padding: 0px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
  }

  .selected > .image-container > img {
    max-height: 16px;
    max-width: 16px;
  }

  .selected > .name {
    width: 100%;
    padding: 0px 0px 0px 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    font-size: 16px;
    font-family: Default-PromptPai-Medium;
    line-height: 36px;
  }

  .selected > .placeholder {
    width: 100%;
    padding: 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    font-size: 15px;
    color: rgb(175, 175, 175);
    line-height: 36px;
  }

  .arrow-dropdown {
    position: absolute;
    top: 10px;
    right: 10px;
    /* z-index: 1000; */
    z-index: 10;
    width: 16px;
    height: 16px;
    transform: rotate(180deg);
    user-select: none;
  }

  .arrow-dropdown.active {
    transform: rotate(0deg);
  }

  .dropdown {
    position: absolute;
    background-color: rgb(255, 255, 255);
    width: 100%;
    left: 0px;
    padding: 10px;
    box-sizing: border-box;
    z-index: 20;
    box-shadow: 0px 4px 4px 4px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  .dropdown > input[type=search] {
    border: 1px solid rgb(120, 120, 120);
    width: 100%;
    height: 36px;
    padding: 5px;
    border-radius: 4px;
    font-size: 16px;
    font-family: Default-PromptPai-Medium;
    line-height: 36px;
    text-indent: 2px;
  }

  .dropdown > input[type=search]::-webkit-search-cancel-button{
    appearance: auto;
  }

  .option-list {
    margin-top: 5px;
    overflow-y: auto;
    max-height: 200px;
  }

  .option-list::-webkit-scrollbar {
    background-color: rgb(251, 251, 251);
  }
  .option-list::-webkit-scrollbar-thumb {
    border: 2px solid rgb(251, 251, 251);
  }

  .option-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-height: 36px;
    margin: 4px 0px;
    cursor: pointer;
  }

  .option-row > .icon-category-container {
    height: 36px;
    width: 36px;
    padding: 8px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .option-row > .icon-category-container > img {
    max-height: 16px;
    max-width: 16px;
  }

  .option-row > .name {
    width: 100%;
    padding: 2px 0px 0px 10px;
    font-size: 16px;
  }

  .selected-row {
    background-color: rgb(227, 227, 227);
  }
</style>



// WEBPACK FOOTER //
// src/components/DropdownWidget.vue